export default (price) => {
  const priceArr = price.toString().split('.');
  let returnPrice = price;
  if (priceArr.length > 1) {
    if (priceArr[1].length === 1) {
      priceArr[1] = `${priceArr[1]}0`;
    }
    returnPrice = `${priceArr[0]}<span class="util-hide">.</span><span class="cents">${priceArr[1]}</span>`;
  }
  return returnPrice;
};
